'use strict';
import { tns } from "tiny-slider"

class QuoteCarousel {
    constructor(container) {
        const sliderEl = container.querySelector('.quote-carousel__carousel');
        if (!sliderEl) return;

        const slider = tns({
            container: sliderEl,
            slideBy: 'page',
            autoplay: window.autoScroll,
            autoplayTimeout: 6000,
            loop: true,
            controls: true,
            nav: true,
            speed: 400,
            mouseDrag: true,
            arrowKeys: true,
            controlsText: ['', ''],
        });

        this.setupAccessibility(container, slider);

        if (window.autoScroll) {
            this.addPauseButton(slider, container);
        }
    }

    setupAccessibility(container, slider) {
        if (!container) return;

        const info = slider.getInfo();

        container.setAttribute('role', 'group');
        container.setAttribute('aria-roledescription', 'karusell');
        container.setAttribute('aria-label', 'Citat');

        if (info.prevButton) {
            info.prevButton.removeAttribute('tabindex');
            info.prevButton.setAttribute('aria-label', 'Föregående citat');
        }
        if (info.nextButton) {
            info.nextButton.removeAttribute('tabindex');
            info.nextButton.setAttribute('aria-label', 'Nästa citat');
        }

        const tnsNav = container.querySelector('.tns-nav');
        if (tnsNav) {
            tnsNav.setAttribute('role', 'tablist');
            tnsNav.setAttribute('aria-label', 'Välj citat');
            const navButtons = tnsNav.querySelectorAll('button');
            navButtons.forEach((btn, index) => {
                btn.removeAttribute('tabindex');
                btn.setAttribute('role', 'tab');
                btn.setAttribute('aria-label', `Visa citat ${index + 1} av ${navButtons.length}`);
            });
        }

        this.setupSlideAccessibility(slider);

        slider.events.on('indexChanged', () => {
            this.setupSlideAccessibility(slider);
        });
    }

    setupSlideAccessibility(slider) {
        const info = slider.getInfo();
        const slides = Array.from(info.slideItems);
        const currentIndex = info.index;

        slides.forEach((slide, index) => {
            const isVisible = index === currentIndex;

            slide.setAttribute('aria-hidden', !isVisible);

            const focusableElements = slide.querySelectorAll('a, button, input, select, textarea, [tabindex]');
            focusableElements.forEach(el => {
                if (isVisible) {
                    el.removeAttribute('tabindex');
                } else {
                    el.setAttribute('tabindex', '-1');
                }
            });
        });
    }

    addPauseButton(slider, container) {
        const tnsControls = container.querySelector('.tns-controls');
        if (!tnsControls) return;

        const prevButton = tnsControls.querySelector('button');
        if (!prevButton) return;

        const leftWrapper = document.createElement('div');
        leftWrapper.className = 'quote-carousel__controls-left';

        const pauseButton = document.createElement('button');
        pauseButton.className = 'quote-carousel__pause-btn';
        pauseButton.setAttribute('type', 'button');
        pauseButton.setAttribute('aria-label', 'Pausa automatisk bläddring');
        pauseButton.setAttribute('aria-pressed', 'false');
        pauseButton.innerHTML = '<i class="fa-solid fa-pause" aria-hidden="true"></i>';

        leftWrapper.appendChild(pauseButton);
        tnsControls.insertBefore(leftWrapper, prevButton);
        leftWrapper.appendChild(prevButton);

        tnsControls.style.marginLeft = '-24px';

        let isPaused = false;
        pauseButton.addEventListener('click', () => {
            if (isPaused) {
                slider.play();
                pauseButton.innerHTML = '<i class="fa-solid fa-pause" aria-hidden="true"></i>';
                pauseButton.setAttribute('aria-label', 'Pausa automatisk bläddring');
                pauseButton.setAttribute('aria-pressed', 'false');
            } else {
                slider.pause();
                pauseButton.innerHTML = '<i class="fa-solid fa-play" aria-hidden="true"></i>';
                pauseButton.setAttribute('aria-label', 'Starta automatisk bläddring');
                pauseButton.setAttribute('aria-pressed', 'true');
            }
            isPaused = !isPaused;
        });
    }
}

function init() {
    document.querySelectorAll('.quote-carousel').forEach(container => {
        new QuoteCarousel(container);
    });

    const isCampaignPage = document.body.classList.contains('campaign');
    if (isCampaignPage) {
        document.querySelectorAll('.quote-carousel').forEach(quoteCarousel => {
            const tnsControls = quoteCarousel.querySelector('.tns-controls');
            if (tnsControls) {
                const tnsNav = quoteCarousel.querySelector('.tns-nav');
                let tnsNavPositionInfo = tnsNav.getBoundingClientRect();
                let tnsNavWidth = tnsNavPositionInfo.width;
                let tnsNavWidthGap = tnsNavWidth + 32;
                tnsControls.style.gap = tnsNavWidthGap + 'px';
            }
        });
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
